import { gql } from "@apollo/client";

export const setLensCategory = gql`
    mutation setLensCategory($lensId: ID!, $primaryCategoryId: ID!, $secondaryCategoryId: ID) {
        setLensCategory(
            input: { lensId: $lensId, primaryCategoryId: $primaryCategoryId, secondaryCategoryId: $secondaryCategoryId }
        ) {
            lens {
                id
                status
                primaryCategoryId
                secondaryCategoryId
            }
        }
    }
`;
